export default "__VITE_ASSET__DE$yaLl$__"